var map = {
	"./boecker.jpg": "1a84",
	"./desilva.jpg": "a35e",
	"./employee_dummy.jpg": "7c3d",
	"./etakkem.jpg": "0cfd",
	"./gorldt.jpg": "5527",
	"./hoelling.jpg": "d0e7",
	"./jacobs.jpg": "e098",
	"./jobski.jpg": "083c",
	"./kraeft-neu.jpg": "f32a",
	"./kraeft.jpg": "cebb",
	"./kuever.jpg": "8230",
	"./nusche.jpg": "5ec2",
	"./pessing.jpg": "870b",
	"./schottler.jpg": "5fd9",
	"./schumacher.jpg": "7b8c",
	"./schwack.jpg": "ef1d",
	"./schwenzfeuer.jpg": "3544",
	"./siemer.jpg": "e40c",
	"./thamm.jpg": "c7f6",
	"./thorenz.jpg": "9e3c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fd1e";